import { useEffect, useRef, useState } from "react";
import "./StatusDropdown.css";

export default function StatusDropdown({
  value,
  options = [],
  getLabel,
  onChange,
  editable = true,
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Only listens while the menu is open (tables render one per row).
  useEffect(() => {
    if (!open) return undefined;

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const handleKeyDown = (e) => {
    if (e.key === "Escape" && open) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(false);
      buttonRef.current?.focus();
    }
  };

  return (
    <div
      ref={dropdownRef}
      className={`ui-status-select ${className}`}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={handleKeyDown}
    >
      <button
        ref={buttonRef}
        type="button"
        aria-haspopup={editable ? "true" : undefined}
        aria-expanded={editable ? open : undefined}
        className={`ui-status-current ui-status-${value || ""}`}
        disabled={!editable}
        onClick={() => {
          if (editable) setOpen((prev) => !prev);
        }}
      >
        {getLabel ? getLabel(value) : value}
      </button>

      {editable && open && (
        <div className="ui-status-menu">
          {options
            .filter((option) => option !== value)
            .map((option) => (
              <button
                key={option}
                type="button"
                className={`ui-status-option ui-status-${option}`}
                onClick={() => {
                  onChange?.(option);
                  setOpen(false);
                  buttonRef.current?.focus();
                }}
              >
                {getLabel ? getLabel(option) : option}
              </button>
            ))}
        </div>
      )}
    </div>
  );
}